module.exports = __webpack_public_path__ + "static/apple-touch-icon-18ec0d7f46fbe3d14f18219536d85d06.png";